// extracted by mini-css-extract-plugin
export default {"headerHeight":"7rem","blackFadeBright":"rgba(0,0,0,0.8)","mobileBreakpoint":"700px","tabletBreakpoint":"1050px"};